export function checkAccessOrgByRole(user, organizationId, roles) {
    return user && user.organizationsRoles && user.organizationsRoles[`${organizationId}`]
        ? roles.includes(user.organizationsRoles[`${organizationId}`])
        : false;
}

export function checkAccessByRole(user, roles) {
    return user && user.role ? roles.includes(user.role) : false;
}
